import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsc_inline_editing_flag_fix');
	},
};
